import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "avbWrapper" }
const _hoisted_2 = { class: "elevation-1 chartWrapper avbCard" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_chart = _resolveComponent("base-chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "chart-title d-block text-center" }, "Actual vs Benchmark IRR", -1)),
      _createVNode(_component_base_chart, {
        options: _ctx.chartOptions,
        "scroll-options": _ctx.chartSize
      }, null, 8, ["options", "scroll-options"])
    ])
  ]))
}